export const EventoSlug = (nombre, id) => {
    return  encodeURIComponent(nombre.replace(/ /g, '&')+'-'+id);
}